import { render, staticRenderFns } from "./NigerianSchoolsData.vue?vue&type=template&id=31c7e678"
import script from "./NigerianSchoolsData.vue?vue&type=script&lang=js"
export * from "./NigerianSchoolsData.vue?vue&type=script&lang=js"
import style0 from "./NigerianSchoolsData.vue?vue&type=style&index=0&id=31c7e678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports